import type { LinkToMessagesSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-messages';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LinkToMessages: TemplateOnlyComponent<LinkToMessagesSignature> =
  <template>
    <a href="#" ...attributes>{{yield}}</a>
  </template>;

export { LinkToMessages };
